//import { RequestProps } from '../index.types';
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
//prePageCall is as server side method to be called from:
//1. [[page.tsx]] to fetch model.json from AEM Author/Publish instances
//2. Product specific pages to fetch model.json for end user.
//3. Call dataLayer, session, interceptor and return the data as props to pages.
import { fetchModel } from '@adobe/aem-react-editable-components';
import { isEmpty } from '@marriott/shared/mi-helper-utils';
import { isLocalDev } from '@marriott/mi-apollo-client-utils';
import { inspect } from 'util';

import {
  getFeatureFlagData,
  getSessionData,
  respGridUtil,
  getSessionDataWithParams,
  getPageModel,
  getCachedPageModel,
} from './helpers';
import { logger } from '@marriott/mi-headless-utils';
import { MOCK_SESSION_ID, REDIRECT_URL_SURVEY } from './constants';
import { getDataLayer } from './dataLayer';
import { interceptor } from './interceptor';
import { useGlobalStore } from '@marriott/mi-store-utils';
import { updatePrearrivalSessionData } from '../lib/reservationPrePageCall';

const {
  NEXT_PUBLIC_AEM_AUTH,
  REDIRECT_URL,
  NEXT_PUBLIC_AEM_HOST,
  NEXT_PUBLIC_APP_NAME,
  USE_MOCK_MODEL,
  INVALID_REDIRECT_URL,
  SKIP_DATALAYER_CALL,
  SKIP_SESSION_CALL,
  SKIP_PREARRIVAL_SESSION_VALIDATION,
  SKIP_INTERCEPTOR_CALL,
  SKIP_FEATURE_FLAG_CALL,
  NEXT_AEM_AUTH,
  IS_LOCAL_DEV,
  IS_LOCAL_AEM_DEV,
  IS_SESSION_APP_GET_CALL_V1,
  DISABLE_APOLLO_CLIENT,
  APOLLOGRAPHQL_PUBLIC_ACCEPT_LANG = '',
  APOLLOGRAPHQL_PUBLIC_CLIENT_VERSION = '',
  APOLLOGRAPHQL_PUBLIC_CLIENT_NAME = '',
  APOLLOGRAPHQL_PUBLIC_APPLICATION_NAME = '',
  APOLLOGRAPHQL_PUBLIC_REQUIRE_SAFELISTING = '',
  APOLLOGRAPHQL_AUTH_TOKEN = '',
  APOLLOGRAPHQL_FULL_NGINX_ENDPOINT = '',
  APOLLOGRAPHQL_PUBLIC_LOCAL_DEV = '',
  APOLLOGRAPHQL_PUBLIC_LOWER_ENV_PATH = '',
  APOLLOGRAPHQL_PUBLIC_HIGHER_ENV_PATH = '',
  DEPLOYED_ENV_TYPE = '',
  APOLLOGRAPHQL_PUBLIC_DEBUG_LOG = '',
  APOLLOGRAPHQL_LOCAL_ENDPOINT = '',
  IS_CN_ENV,
  UXL_IMAGE_CACHE_DOMAIN = '',
  ROUTE_REQUEST_THROUGH_HYBRID_APP,
  ENABLE_DYNAMIC_LOCALE_REQUEST,
} = process.env;

declare global {
  // eslint-disable-next-line no-var
  var loggerInstance: CallableFunction;
}

const resolvePrearrivalBrandCode = (propertyConfig?: {
  brand_cd?: string;
  brand_name?: string;
  non_branded_flg?: string;
}) => {
  let brandCode = propertyConfig?.brand_cd;

  if (propertyConfig?.brand_name === 'Ritz-Carlton Reserve') {
    brandCode = 'RZR';
  }

  if (brandCode === 'FS') {
    brandCode = 'MC';
  }

  if (propertyConfig?.non_branded_flg === 'Y') {
    brandCode = 'LG';
  }

  return brandCode;
};

//prePageCall is as server side method to be called from:
//1. [[page.tsx]] to fetch model.json from AEM Author/Publish instances
//2. Product specific pages to fetch model.json for end user.
export function prePageCall(
  productSpecificCalls:
    | boolean
    | ((context?: { [key: string]: any }, parallellCallsArr?: any, interceptorResponse?: any) => Promise<any>) = false,
  mockModel = {},
  removeServerEnv = false,
  preserveLocaleInUrl = false,
  postAEMModelOperations?: (model?: any, context?: any) => any
) {
  return async (context: { [key: string]: any }) => {
    //Initialization start
    const { req, res, query } = context;
    let pagePath = '';
    const resolvedUrlString: string = context['resolvedUrl'] ?? req.url;
    const isAuthorMode = resolvedUrlString.includes('isAuthorMode');
    let resolvedUrl = resolvedUrlString.split('?')[0];
    const isAppbuilderDemo: boolean = resolvedUrlString.includes('appBuilderDemo');
    const isAccDemo: boolean = resolvedUrlString.includes('accDemo');
    const requestUri = resolvedUrl;
    const headersData = req?.headers;
    const cookies = req?.cookies;
    let interceptorResponse;
    let productSpecificProps: any = {};
    let model;
    let selector;
    let noCache;
    let eaaPageIndicator;
    let errorVal = null;
    let currentLocale =
      ENABLE_DYNAMIC_LOCALE_REQUEST && !resolvedUrlString.startsWith('/my') ? resolvedUrlString.split('/')[1] : 'en_US';
    const requestId = (req.headers['x-request-id'] as string) ?? '';
    const sessionIDVal = req?.cookies?.sessionID ?? MOCK_SESSION_ID;
    context['sessionData'] = sessionIDVal;
    let apolloEnvVars: { [key: string]: string } = {};
    let cnEnvVars: { [key: string]: string } = {};
    global.loggerInstance = logger({
      sessionID: req?.cookies?.sessionID,
      requestID: req.headers['x-request-id'],
    }) as CallableFunction;
    const parallelCallsResponse: { [key: string]: any } = {};
    const { log } = global.loggerInstance('Pre Page');
    const isLoggedIn = cookies?.UserIdToken ? true : false;
    log.error(`Dynamic Locale Status: ${ENABLE_DYNAMIC_LOCALE_REQUEST}`);
    log.error(`Skip SKIP_PREARRIVAL_SESSION_VALIDATION: ${SKIP_PREARRIVAL_SESSION_VALIDATION}`);
    log.error(`current locale set to: ${currentLocale}`);
    log.error(`Is User signed in: ${isLoggedIn}`);
    log.error(`Page call 1 : confirmationNumber : ${isAppbuilderDemo}`);
    let sessionRedirect = false;
    let interceptorCookieArr: any;
    let sessionCookieArr: any;
    const redirectSurveyUrl = REDIRECT_URL_SURVEY;
    //log.error(`URL Gen ${currentLocale.toLowerCase()}${REDIRECT_URL}`);
    log.error(`URL Gen1 ${redirectSurveyUrl}`);
    const preservedLocalUrl = preserveLocaleInUrl ? `${redirectSurveyUrl}` : redirectSurveyUrl;
    const destinationUrl = ROUTE_REQUEST_THROUGH_HYBRID_APP === 'true' ? preservedLocalUrl : '/my/prearrival.mi';
    const redirect = {
      redirect: {
        permanent: false,
        destination: destinationUrl,
        error: true,
      },
    };

    const preHeader: Record<string, string> = {
      'Content-Type': 'application/json',
      'x-request-id': req.headers['x-request-id'] || '',
      Cookie: `sessionID=${req?.cookies?.sessionID};UserIdToken=${
        req?.cookies?.UserIdToken ? req?.cookies?.UserIdToken : ''
      }`,
      'x-host': req.headers['x-host'] || '',
      'accept-language': req.headers['accept-language'] || '',
    };

    //Initialization end

    // Redirection to Custom 404 Page - Commenting the code to check redirection from Nginx
    // if (!isAuthorMode && isFromSlug && INVALID_REDIRECT_URL) {
    //   return { redirect: { destination: INVALID_REDIRECT_URL, permanent: false } };
    // }

    log.error(`NgInx Request Headers, ${JSON.stringify(headersData)}`);

    log.error(`Preprocessor execution started`);
    //log.error(`Preprocessor Print Request: ${inspect(req)}`);
    //log.error(`Preprocessor Print Request cookies: ${inspect(req?.cookies)}`);

    log.error(`Preprocessor: currentLocale: ${currentLocale}`);
    log.error(`Preprocessor: REQUEST ID: ${requestId}`);
    log.error(`Preprocessor: Resolved url: ${resolvedUrl}`);
    log.error(`Preprocessor: resolvedUrlString url: ${resolvedUrlString}`);

    //function to generate list of parallel api calls based on env flags
    function generateParallelCallsList(): Array<{ [key: string]: Promise<any> | string }> {
      const parallelCallsArray: Array<{ [key: string]: Promise<any> | string }> = [];
      if (SKIP_SESSION_CALL !== 'true') {
        const sessionId = req?.cookies?.sessionID ?? MOCK_SESSION_ID;
        if (IS_SESSION_APP_GET_CALL_V1 === 'true') {
          parallelCallsArray.push({
            api: 'sessionData',
            apiHandler: getSessionDataWithParams(preHeader, IS_LOCAL_DEV === 'true', isAuthorMode),
          });
        } else {
          parallelCallsArray.push({
            api: 'sessionData',
            apiHandler: getSessionData(sessionId, IS_LOCAL_DEV === 'true', isAuthorMode),
          });
        }
      }
      if (SKIP_DATALAYER_CALL !== 'true' && !isAuthorMode) {
        parallelCallsArray.push({ api: 'dataLayer', apiHandler: getDataLayer(req, resolvedUrl, currentLocale, query) });
      }
      if (SKIP_FEATURE_FLAG_CALL !== 'true' && !isAuthorMode) {
        parallelCallsArray.push({ api: 'getFeatureFlagData', apiHandler: getFeatureFlagData() });
      }
      return parallelCallsArray;
    }

    //interceptor call is the first api call on serveside
    if (SKIP_INTERCEPTOR_CALL !== 'true' && IS_LOCAL_DEV !== 'true' && !isAuthorMode) {
      log.error(`Preprocessor Interceptor Call started`);
      try {
        interceptorResponse = await interceptor(req, resolvedUrlString);
        log.error(`Preprocessor Interceptor Data: ${inspect(interceptorResponse?.data)}`);
        // locale value present in interceptor response
        // if (ROUTE_REQUEST_THROUGH_HYBRID_APP) {
        //   currentLocale = interceptorResponse?.data?.requestAttributes?.pageManagerRequest?.global?.localeKey;
        // } else {
        //   currentLocale = 'en_US';
        // }
        currentLocale =
          ENABLE_DYNAMIC_LOCALE_REQUEST && !resolvedUrlString.startsWith('/my')
            ? resolvedUrlString.split('/')[1]
            : 'en_US';
        log.error(`Preprocessor Interceptor locale value: ${currentLocale}`);

        interceptorCookieArr = interceptorResponse?.headers?.['set-cookie'] ?? '';
        log.error(`Preprocessor Interceptor cookieArray value: ${inspect(interceptorCookieArr)}`);
        //Interceptor redirect rules for account team only
        if (
          process.env['NEXT_PUBLIC_APP_INTERCEPTOR_ID'] === 'account' ||
          process.env['NEXT_PUBLIC_APP_INTERCEPTOR_ID'] === 'groups'
        ) {
          if (interceptorResponse?.data?.redirect && interceptorResponse?.data?.redirectionPath) {
            return {
              redirect: {
                permanent: false,
                destination: interceptorResponse?.data?.redirectionPath,
              },
            };
          }
        }
      } catch (e) {
        log.error(`Interceptor call failed with error ${e}`);
        //redirecting user to configured page if interceptor api fails
        return redirect;
      }
    }

    const parallellCallsArr: Array<{ [key: string]: any }> = generateParallelCallsList(); //list of parallel apis to be made

    //Using Promise.allSettled because flow should not stop if any one of the api call fails.
    // For eg: If datalayer fails session and feature flag calls should not be skipped
    const responses = await Promise.allSettled(parallellCallsArr.map(parallelCall => parallelCall['apiHandler']));
    responses.forEach((resp: { [key: string]: any }, index) => {
      if (resp['status'] === 'fulfilled') {
        //if api call is success add the response to return object
        parallelCallsResponse[parallellCallsArr[index]['api']] = resp['value'];
        if (parallellCallsArr[index]['api'] === 'sessionData') {
          parallelCallsResponse[parallellCallsArr[index]['api']] = resp['value']['sessionData'];
          useGlobalStore.setState({ sessionData: resp['value']['sessionData'] });
          const cookieArr = resp['value'].sessionHeader?.['set-cookie'] ?? '';
          const prearrivalSessionData = resp['value']['sessionData']?.cacheData?.data?.Prearrival;
          sessionCookieArr = cookieArr;
          if (cookieArr) {
            res.setHeader('Set-Cookie', cookieArr);
          }
          log.error(`prearrival responses: ${inspect(prearrivalSessionData?.brandCode)}`);
          log.error(`!=SKIP_PREARRIVAL_SESSION_VALIDATION ${SKIP_PREARRIVAL_SESSION_VALIDATION !== 'true'}`);
          // if brand code is missing, redirect invalid session
          log.debug(`vinoth brandcode:${inspect(resp['value']['sessionData']?.cacheData)}`);
          if (
            requestUri.includes('my/prearrival/') &&
            !requestUri.includes('my/prearrival/guest-details') &&
            !isAccDemo &&
            !isAppbuilderDemo &&
            !isAuthorMode &&
            !prearrivalSessionData?.brandCode &&
            !prearrivalSessionData?.marshaCode &&
            SKIP_PREARRIVAL_SESSION_VALIDATION !== 'true'
          ) {
            log.error('[PREPROCESSOR-LOGS] missing brandcode in session data');
            log.error(`[PREPROCESSOR-LOGS] missing brandcode in session data and also marsha in session fallback`);
            sessionRedirect = true;
          }
        }

        // below code add Affiliate cookie if user landed from affiliate lint and this is common pre Processor similar implementation we seen in books preprocessor.
        if (interceptorCookieArr) {
          res.setHeader(
            'Set-Cookie',
            sessionCookieArr ? [...sessionCookieArr, ...interceptorCookieArr] : interceptorCookieArr
          );
        }
      } else if (resp['status'] === 'rejected') {
        //if session call fails redirect user to configured page and datalayer, feature flag apis fail silently
        if (parallellCallsArr[index]['api'] === 'sessionData' && !IS_LOCAL_DEV && !isAuthorMode) {
          sessionRedirect = true;
        }
      }
    });

    if (sessionRedirect) {
      return redirect;
    }

    //fetch any product specific data using the callback passed by product specific [[..page.tsx]].
    if (productSpecificCalls && typeof productSpecificCalls === 'function') {
      productSpecificProps = await productSpecificCalls(context, parallelCallsResponse, interceptorResponse?.data);
      // update resolved URL incase any product specific URI exists
      log.error(`[PREPROCESSOR-LOGS] PRODUCT SPECIFIC PROPS, ${inspect(productSpecificProps)}`);

      if (productSpecificProps?.uri && !isAuthorMode) {
        resolvedUrl = productSpecificProps?.uri;
      }
    }

    //IF product specific call fails and user has to be redirected to some error page when it is not local or author instance
    if (productSpecificProps?.error && productSpecificProps?.error.value === true && !isLocalDev && !isAuthorMode) {
      log.error(`[PREPROCESSOR-LOGS] PRODUCT SPECIFIC ERROR, ${inspect(productSpecificProps?.error)}`);

      return productSpecificProps?.error?.redirect;
    }
    log.error(`cookies.prearrivalParamsExist ${inspect(cookies.prearrivalParamsExist)}`);

    // Redirection to Custom 404 Page - Commenting the code to check redirection from Nginx
    if (!isAuthorMode && INVALID_REDIRECT_URL) {
      log.error(`Invalid Url Error Encountered: ${res.statusCode}`);
      res.statusCode = 404;
      log.error(`Invalid Url Error Set Status: ${res.statusCode}`);
      res.end();
    }

    // AEM call to fetch models
    try {
      log.error('Preprocessor:Model Call started');
      if (String(USE_MOCK_MODEL) === 'true') {
        // To use mock model for local development set env USE_MOCK_MODEL to true in env.development file and
        //pass mockModel as parameter to prePageCall function
        log.error('Preprocessor utilizing mock model');
        // Dynamic Import of Mock Model only in development - Not needed in productions, hence this check (Bundle Size)
        if (typeof mockModel === 'function') {
          mockModel = await mockModel();
        }
        model = respGridUtil(mockModel);
        if (postAEMModelOperations) {
          model = await postAEMModelOperations(model, context);
        }
      } else {
        // The third OR condition is a fallback unless application teams start using IS_LOCAL_AEM_DEV for conneting to local AEM instance
        log.error(`isAuthorMode: ${isAuthorMode}`);
        log.error(`IS_LOCAL_AEM_DEV: ${IS_LOCAL_AEM_DEV}`);
        log.error(`isLocalDev: ${isLocalDev}`);

        if (isAuthorMode) {
          //By default fetch model from local AEM author instance for local development
          log.error('Preprocessor: author mode detected');
          const pagePathArr = query['page'] as Array<string>;
          pagePath = `/${pagePathArr?.join('/')}`;
          log.error(`Preprocessor: REQUEST RESOLVED URL: ${resolvedUrl + '.model.json'}`);
          log.error(`Preprocessor NEXT_PUBLIC_AEM_HOST_URL : ${NEXT_PUBLIC_AEM_HOST}`);
          log.error(`Preprocessor NEXT_AEM_AUTH : ${NEXT_AEM_AUTH}`);

          const resolvedFullString = `${resolvedUrl}`;

          model = await fetchModel({
            pagePath: resolvedFullString,
            host: NEXT_PUBLIC_AEM_HOST,
            options: {
              headers: {
                Authorization: NEXT_AEM_AUTH as string,
                marshaCode: productSpecificProps.marshaCode,
              },
            },
          });
          if (productSpecificProps?.marshaCode === null) {
            errorVal = 'Error loading property configuration. Please contact an administrator for assistance.';
            log.error(`Error1`);
          } else {
            if (isEmpty(model)) {
              log.error(`Error2`);
              errorVal = 'Invalid marsha code or configuration does not exist';
            }
          }
        } else {
          if (productSpecificProps?.marshaCode) {
            selector = productSpecificProps?.marshaCode;
          }
          if (productSpecificProps?.currentLocale) {
            currentLocale = productSpecificProps?.currentLocale;
          }
          if (productSpecificProps?.isEAA === true) {
            eaaPageIndicator = 'EAA';
          }
          // if (ROUTE_REQUEST_THROUGH_HYBRID_APP != 'true' && productSpecificProps?.noCache) {
          //   noCache = productSpecificProps?.noCache;
          // }
          if (productSpecificProps?.noCache) {
            noCache = productSpecificProps?.noCache;
          }
          //For lower and higher envs fetch model via hybrid config app
          // Will work passing marsha code through selectors
          log.error(`Hybrid CALL: ${ROUTE_REQUEST_THROUGH_HYBRID_APP}`);
          log.error(`Cache CALL: ${noCache}`);
          let modelData = null;
          if (ROUTE_REQUEST_THROUGH_HYBRID_APP === 'true' && noCache != 'true') {
            log.error(`Inside Hybrid CALL: ${ROUTE_REQUEST_THROUGH_HYBRID_APP}`);
            modelData = await getCachedPageModel(
              resolvedUrl,
              currentLocale,
              sessionIDVal,
              productSpecificProps?.appId ?? (NEXT_PUBLIC_APP_NAME || ''),
              selector,
              isLoggedIn,
              eaaPageIndicator,
              productSpecificProps?.EXPERIENCE_SEGMENT
            );
          } else {
            log.error(`isLocalDev CALL`);
            modelData = await getPageModel(resolvedUrl, currentLocale, selector, noCache, isAppbuilderDemo);
          }

          if (isEmpty(modelData)) {
            errorVal = 'Invalid marsha_cd or configuration does not exist';
            if (!isAuthorMode) {
              log.error(`page model not available, redirecting to configured page - ${JSON.stringify(redirect)}`);
              return redirect;
            }

            log.error(
              `preprocessor.ts call failed with error ${resolvedUrl} ${inspect({
                props: {
                  ...productSpecificProps,
                },
              })}`
            );
          }
          model = respGridUtil(modelData);
          // merge mbox param with model data in page.tsx
          if (postAEMModelOperations) {
            model = await postAEMModelOperations(model, context);
          }

          if (requestUri.includes('my/prearrival') && !isAuthorMode && productSpecificProps?.didFetchReservationData) {
            try {
              const prearrivalProductSpecificResponse = productSpecificProps?.productSpecificResponse;
              const prearrivalProductSpecificResponseRecord =
                (prearrivalProductSpecificResponse as Record<string, unknown> | null) ?? {};
              const prearrivalAccDown = Object.prototype.hasOwnProperty.call(
                prearrivalProductSpecificResponseRecord,
                'accDown'
              )
                ? prearrivalProductSpecificResponse?.accDown ?? null
                : undefined;

              await updatePrearrivalSessionData(
                {
                  brandCode: resolvePrearrivalBrandCode(model?.accData?.property_config),
                  marshaCode: productSpecificProps?.marshaCode,
                  confirmationNumber: productSpecificProps?.confirmation_no,
                  isMemberFlg: prearrivalProductSpecificResponse?.reservation?.isMemberFlg,
                  reservation: Object.prototype.hasOwnProperty.call(
                    prearrivalProductSpecificResponseRecord,
                    'reservation'
                  )
                    ? prearrivalProductSpecificResponse?.reservation ?? null
                    : undefined,
                  passions: Object.prototype.hasOwnProperty.call(prearrivalProductSpecificResponseRecord, 'passions')
                    ? prearrivalProductSpecificResponse?.passions ?? null
                    : undefined,
                  accDown: prearrivalAccDown,
                  errorData: Object.prototype.hasOwnProperty.call(prearrivalProductSpecificResponseRecord, 'errorData')
                    ? prearrivalProductSpecificResponse?.errorData ?? null
                    : prearrivalAccDown !== undefined
                    ? { accDown: prearrivalAccDown }
                    : undefined,
                },
                sessionIDVal
              );
            } catch (error) {
              log.error(`Error updating prearrival session in preprocessor: ${inspect(error)}`);
            }
          }

          log.error('Pre-processor publish mode Model', inspect(model));
        }
      }

      const getProcessENV = () => {
        const processENV = { ...process.env };
        delete processENV['NEXT_AEM_AUTH'];
        delete processENV['NEXT_PUBLIC_AEM_AUTH'];
        return processENV;
      };

      if (DISABLE_APOLLO_CLIENT !== 'true') {
        apolloEnvVars = {
          APOLLOGRAPHQL_PUBLIC_ACCEPT_LANG,
          APOLLOGRAPHQL_PUBLIC_CLIENT_VERSION,
          APOLLOGRAPHQL_PUBLIC_CLIENT_NAME,
          APOLLOGRAPHQL_PUBLIC_APPLICATION_NAME,
          APOLLOGRAPHQL_PUBLIC_REQUIRE_SAFELISTING,
          APOLLOGRAPHQL_FULL_NGINX_ENDPOINT,
          APOLLOGRAPHQL_PUBLIC_LOCAL_DEV,
          APOLLOGRAPHQL_PUBLIC_LOWER_ENV_PATH,
          APOLLOGRAPHQL_PUBLIC_HIGHER_ENV_PATH,
          DEPLOYED_ENV_TYPE,
          APOLLOGRAPHQL_PUBLIC_DEBUG_LOG,
          APOLLOGRAPHQL_LOCAL_ENDPOINT,
        };
        if (IS_LOCAL_DEV === 'true') {
          // returning auth token only for local development. For serverside calls auth token will be read from process.env
          apolloEnvVars['APOLLOGRAPHQL_AUTH_TOKEN'] = APOLLOGRAPHQL_AUTH_TOKEN;
        }
      }
      //IS_CN_ENV is true , then we will be using UXL_IMAGE_CACHE_DOMAIN = https://cache.marriott.com.cn for CN.
      if (IS_CN_ENV) {
        cnEnvVars = {
          UXL_IMAGE_CACHE_DOMAIN,
        };
        log.error('cnEnvVars ', cnEnvVars);
      }
      return {
        props: {
          isAuthorMode,
          model: model,
          pagePath,
          resolvedUrl,
          requestUri,
          requestId,
          currentLocale,
          datalayerUrl: process.env['CLIENT_DATA_LAYER_PATH'] || '',
          headersData,
          cookies,
          query,
          selector: selector ?? '',
          ...(!removeServerEnv && { serverENV: JSON.stringify(getProcessENV()) }),
          params: context?.['params'] ? context?.['params'] : '',
          USE_MOCK_MODEL: String(process.env['USE_MOCK_MODEL']) === 'true',
          ...parallelCallsResponse,
          ...productSpecificProps,
          interceptorResponse: interceptorResponse?.data || {},
          apolloEnvVars,
          cnEnvVars,
          errorVal,
        },
      };
    } catch (e) {
      log.error(`prepage call error occurred: ${e}`);
      if (!isAuthorMode) {
        return redirect;
      } else {
        log.error(`Preprocessor: call to AEM author failed`);
      }
    }
  };
}
